import {BaseCartController} from '../../domain/controllers/BaseCartController';
import {CART_ORIGIN} from '../../common/constants';
import {defaultStyles} from './defaultStyles';
import {settingsParams} from './settingsParams';
import {wixcodePublicApi} from './WixCode/wixcodePublicApi';
import {CartLayout, ICartStyleSettings} from '../../types/app.types';
import {getFreeTextKeys} from '../../domain/utils/settings.utils';
import {StoresWidgetID} from '@wix/wixstores-client-core';

export class CartController extends BaseCartController {
  protected getOrigin() {
    return CART_ORIGIN;
  }

  protected getWidgetId() {
    return StoresWidgetID.CART;
  }

  protected getCartLayout(): CartLayout {
    return CartLayout.CART;
  }

  protected getDefaultSettings(): ICartStyleSettings {
    return defaultStyles;
  }

  public exports = () => wixcodePublicApi(this.setVeloInputs);

  public getFreeTexts(): string[] {
    return getFreeTextKeys(settingsParams);
  }
}
